// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!../../css/AProfileDialog.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#dialog-overlay.DocSubmissionPreviewDialog-profile-dialog .dialog-container {\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n\r\n    border-radius: 0 !important;\r\n    height: 100%;\r\n    width: calc(100% - 30px);\r\n}\r\n\r\n#dialog-overlay.DocSubmissionPreviewDialog-profile-dialog docuseal-builder {\r\n    height: 100% !important;\r\n    display: block;\r\n    background: rgb(245 245 245);\r\n    margin: -5px 3px -10px -7px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
